import {Pipe, PipeTransform} from '@angular/core';
import {TypeUtils} from "../utils/type-utils";

@Pipe({
    name: 'filterByProperty',
    standalone: false
})
export class FilterByPropertyPipe implements PipeTransform {

  transform<T>(items: T[], properties: object): T[] {
    const hasNoneEmptyProperty: boolean = <any>Object.values(properties).reduce((hasNonEmptyProperty: boolean, value: any) => {
      return (value || [0, false].indexOf(value) !== -1) ? true : hasNonEmptyProperty;
    }, false);

    return hasNoneEmptyProperty ? items.filter((item) => {
      let validItem: boolean = true;

      for (const key in properties) {
        if (!properties.hasOwnProperty(key)) {
          continue;
        }

        let value: any = properties[key];
        if (validItem && value || [0, false].indexOf(value) !== -1) {
          let itemValue: any = item[key];
          if (TypeUtils.isArray(itemValue)) {
            if (itemValue.indexOf(value) !== -1) {
              return validItem;
            }
          }
          if (TypeUtils.isArray(value)) {
            if (value.includes(itemValue) || !value.length) {
              return validItem;
            }
          }
          if (TypeUtils.isString(itemValue) && TypeUtils.isString(value)) {
            itemValue = itemValue.toLowerCase();
            value = value.toLowerCase();
          }


          if (itemValue !== value) {
            validItem = false;
            return false;
          }
        }
      }
      return validItem;
    }) : items;
  }

}
